import bus from './components/Bus.js'

import smDic from './components/Dictionary.vue'
import smTagButton from './components/TagButton.vue'
import smEditor from './components/AceEditor.vue'
import smMethodButton from './components/MethodButton.vue'
import smQueryBuilder from './components/QueryBuilder.vue'

Vue.component('sm-query-builder', smQueryBuilder);
Vue.component('sm-dic', smDic);
Vue.component('sm-editor', smEditor);
Vue.component('sm-method-button', smMethodButton);
Vue.component('sm-tag-button', smTagButton);

var collapseMixin = {
	data: {
		collapse: 'sm-collapsed'
	},
	methods: {
		onCollapse: function() {
			this.collapse == '' ? this.collapse = 'sm-collapsed' : this.collapse = '';
		}
	},
	computed: {
		sign: function() {
			var sign;
			if (this.collapse == '') {
				sign = '&minus;';
			} else {
				sign = '&plus;';
			}
			return sign;
		}
	}
}
var dicMixin = {
	data: {
		rows: []
	},
	methods: {
		onRows: function(rows) {
			this.rows = rows;
		},
	},
}
var editorMixin = {
	data: {
		editor: null,
	},
	methods: {
		addMethod: function(method) {
			this.editor.insert(method);
			this.editor.focus();
		},
		onInit: function(editor) {
			if (this.editor === null) this.editor = editor;
		}
	}	
}
var sm_title = new Vue({
	el: '#sm-title-block',
	mixins: [collapseMixin],
	data: {
		collapse: '',
		shortcode_codes: ''
	}
});
var sm_params = new Vue({
	el: '#sm-parameters-block',
	mixins: [dicMixin, collapseMixin],
	data: {
		collapse: '',
		rows: []
	},
	methods: {
		onRows: function(rows) {
			this.rows = rows.sort( function(a,b) { 
				if ( a.hasOwnProperty('checkbox') && a.checkbox ) { return -1 }
				else if ( b.hasOwnProperty('checkbox') && b.checkbox ) { return 1; }
				else { return 0; } });
			this.onChange(rows);
		},
		onChange: function(data) {
			var string = '';
			data.sort( function(a,b) { 
				if ( a.hasOwnProperty('checkbox') && a.checkbox ) { return -1 }
				else if ( b.hasOwnProperty('checkbox') && b.checkbox ) { return 1; }
				else { return 0; } });
			data.filter(function(row) {
				string += ' ' + row.name + '="' + row.value + '"';
			});
			
			sm_title.shortcode_codes = string.replace(/(\])/g, '}').replace(/(\[)/g, '{');
		}
	}
});
var sm_query = new Vue({
	el: '#sm-query-block',
	mixins: [dicMixin, collapseMixin],
	data: {
		collapse: '',
		isNotHidden: false,
		currentGroup: '',
		qb: [],
		paramsRows: sm_params.rows
	},
	methods: {
		listGroups: function(group) {
			this.currentGroup.className = 'sm-hidden args-group';
			var group = document.getElementById(group + '-group');
			group.className = '';
			this.currentGroup = group;
		},
		editAtts: function(row) {
			bus.$emit('editCurrentArg', 'query-builder', row);
		},
		deleteAtts: function(row) {
			bus.$emit('deleteCurrentArg', 'query-builder', row);
		},
		onCheckMethod: function(method) {
			bus.$emit('checkMethod', 'query-dic', method);
		},
		onQueryChange: function(values, method) {
			var rows = [{
				name: method,
				value: values
			}];
			bus.$emit('fullDic', 'query-dic', rows);
		},
		addTemplateArgs: function(rows) {
			bus.$emit('fullDic', 'query-dic', rows);
		}
	}
});
var sm_query_main = new Vue({
	el: '#sm-query-main-block',
	mixins: [collapseMixin, editorMixin],
	data: {
		collapse: '',
		main: '',
		rows: sm_params.rows
	},
});
var sm_main = new Vue({
	el: '#sm-main-block',
	mixins: [collapseMixin, editorMixin],
	data: {
		collapse: '',
		main_content: '',
		rows: sm_params.rows
	},
});
var sm_scripts = new Vue({
	el: '#sm-scripts-block',
	mixins: [collapseMixin, dicMixin, editorMixin],
	data: {
		collapse: '',
		scripts: '',
		paramsRows: sm_params.rows
	},
});
var sm_styles = new Vue({
	el: '#sm-styles-block',
	mixins: [collapseMixin, dicMixin, editorMixin],
	data: {
		collapse: '',
		styles: '',
		paramsRows: sm_params.rows
	},
});
var sm_integration = new Vue({
	el: '#sm-integration-block',
	mixins: [collapseMixin],
	data: {
		collapse: ''
	},
});


// WEBPACK FOOTER //
// ./src/main.js